// extracted by mini-css-extract-plugin
export var profileTabStructure = "profile-tab-structure_XwEBCxga3l7JtH3r1UfK";
export var profileTabStructureMain = "profile-tab-structure__main_LQfHwmb1eXAC4P8zPpRW";
export var profileTabStructureSeparator = "profile-tab-structure__separator_kVgE81YRFKCQ1_8rin9A";
export var profileTabStructureSidebar = "profile-tab-structure__sidebar_SIJJCiTdveSFeUaOYGHL";